import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-text-edit-modal',
  templateUrl: './text-edit-modal.component.html',
  styleUrls: ['./text-edit-modal.component.css'],
})
export class TextEditModalComponent implements OnInit {
  @Input() modalHeader: string;
  @Input() editText: string;
  @Input() closeButtonText: string;
  @Input() saveButtonText: string;
  @Input() maxlength: number = null;
  modifiedText: string;

  constructor(private ngbActiveModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.modifiedText = this.editText;
  }

  closeModal(): void {
    this.ngbActiveModal.dismiss();
  }
  saveModal(): void {
    this.ngbActiveModal.close(this.modifiedText);
  }
}
